/* @flow */

import ManufacturersProducts from 'views/ManufacturersProducts/ManufacturersProducts';

import { read } from 'permissions/modelMasters';

const modelMastersRoutes: Array<*> = [
  {
    path: '/model-masters',
    title: 'general:document_titles.model_masters.title',
    component: ManufacturersProducts,
    exact: true,
    permissions: read,
  },
];

export default modelMastersRoutes;
